import React from 'react';

interface CalculatorInputProps {
  label: string;
  value: number | '';
  onChange: (value: number) => void;
  icon: React.ReactNode;
  prefix?: string;
  suffix?: string;
  placeholder?: string;
  min?: number;
  max?: number;
  step?: number;
}

const CalculatorInput: React.FC<CalculatorInputProps> = ({
  label,
  value,
  onChange,
  icon,
  prefix,
  suffix,
  placeholder = 'Enter value...',
  min,
  max,
  step = 1
}) => {
  const inputId = React.useId();
  const describedById = React.useId();

  return (
    <div className="relative">
      <label 
        htmlFor={inputId}
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        {label}
      </label>
      <div className="relative rounded-md shadow-sm">
        <div 
          className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-emerald-600"
          aria-hidden="true"
        >
          {icon}
        </div>
        {prefix && (
          <div 
            className="absolute inset-y-0 left-8 pl-3 flex items-center pointer-events-none"
            aria-hidden="true"
          >
            <span className="text-gray-500 sm:text-sm">{prefix}</span>
          </div>
        )}
        <input
          id={inputId}
          type="number"
          inputMode="decimal"
          value={value}
          onChange={(e) => {
            const val = e.target.value;
            onChange(val === '' ? 0 : Number(val));
          }}
          placeholder={placeholder}
          min={min}
          max={max}
          step={step}
          aria-describedby={describedById}
          className="form-input block w-full pl-12 pr-12 py-2 rounded-md border-gray-300 focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm"
        />
        {suffix && (
          <div 
            className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
            aria-hidden="true"
          >
            <span className="text-gray-500 sm:text-sm">{suffix}</span>
          </div>
        )}
      </div>
      <div id={describedById} className="sr-only">
        {`Enter ${label.toLowerCase()}${prefix ? ` in ${prefix}` : ''}${suffix ? ` ${suffix}` : ''}`}
      </div>
    </div>
  );
};

export default CalculatorInput;